import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

export interface ProfileEntry {
  label: ReactNode
  value: ReactNode
}

export interface ProfileCardProps {
  entries: ProfileEntry[]
  className?: string
}

export function ProfileCard({ entries, className }: ProfileCardProps) {
  return (
    <div
      className={cn(
        "bg-card border border-border rounded-md p-5",
        className,
      )}
    >
      <div className="flex flex-col gap-3 text-body">
        {entries.map((entry, i) => (
          <div key={i} className="flex justify-between">
            <span className="text-muted-foreground">{entry.label}</span>
            <span className="text-foreground font-medium">{entry.value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
